// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27 fill=%27%23666%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z%27 clip-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --accent-color: #28a745;
  --danger-color: #dc3545;
  --text-color-dark: #343a40;
  --text-color-medium: #6c757d;
  --text-color-light: #f8f9fa;
  --card-bg: #ffffff;
  --container-bg: #f8f9fa;
  --border-color: #e9ecef;
  --shadow-light: rgba(0, 0, 0, 0.08);
  --shadow-medium: rgba(0, 0, 0, 0.15);
  --spacing-unit: 0.75rem;
}

.exp-main-div-header {
  position: relative;
  z-index: 1;
}
.exp-main-div-header .filter-group label {
  display: block;
  margin-bottom: 8px;
}

.expense-container {
  margin-top: 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: var(--spacing-unit);
  padding: calc(var(--spacing-unit) * 2);
  background: var(--container-bg);
}

.expenses-table {
  width: 100%;
  border-collapse: collapse;
  background-color: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  overflow: hidden;
  font-size: 0.95rem;
  box-shadow: 0 2px 6px var(--shadow-light);
}
.expenses-table thead {
  background-color: #f1f5f9;
}
.expenses-table thead th {
  text-align: left;
  padding: 1rem;
  color: #111827;
}
.expenses-table tbody tr {
  transition: background-color 0.2s ease;
}
.expenses-table tbody tr:hover {
  background-color: #f9fafb;
}
.expenses-table tbody tr td {
  padding: 0.9rem 1rem;
}
.expenses-table tbody tr td:last-child {
  white-space: nowrap;
}
.expenses-table tbody tr td:last-child button {
  margin-right: 0.5rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background-color: #17a2b8;
  color: white;
}
.expenses-table tbody tr td:last-child button:last-child {
  background-color: #dc2626;
}
.expenses-table tbody tr td:last-child button:hover {
  opacity: 0.9;
}

.expense-card-main {
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 0.75rem;
  padding: calc(var(--spacing-unit) * 2);
  transition: all 0.2s ease-in-out;
  position: relative;
}
.expense-card-main .expense-header {
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-bottom: 0.5rem;
  padding-bottom: var(--spacing-unit);
  border-bottom: 1px solid var(--border-color);
}
.expense-card-main .expense-header .expense-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: var(--text-color-dark);
  margin: 0;
}
.expense-card-main .expense-header .expense-actions {
  display: flex;
  gap: 0.75rem;
}
.expense-card-main .expense-header .expense-actions .action-button {
  margin-right: 0.5rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.expense-card-main .expense-header .expense-actions .action-button:hover {
  background: var(--container-bg);
  opacity: 0.9;
}
.expense-card-main .expense-details-grid {
  display: flex;
  flex-direction: column;
  gap: 0.75rem 1.5rem;
  margin-bottom: calc(var(--spacing-unit) * 1.5);
}
.expense-card-main .expense-details-grid .exp-detail-item {
  display: flex;
  align-items: center;
  font-size: 0.95rem;
  color: var(--text-color-medium);
}
.expense-card-main .expense-details-grid .exp-detail-item .detail-icon {
  color: var(--primary-color);
  font-size: 1.15rem;
  margin-right: 0.5rem;
}
.expense-card-main .expense-details-grid .exp-detail-item .detail-label {
  font-weight: 600;
  color: var(--text-color-dark);
  margin-right: 0.25rem;
  width: 100px;
}
.expense-card-main .expense-details-grid .exp-detail-item .detail-value {
  font-weight: 500;
  color: var(--text-color-dark);
}
.expense-card-main .expense-details-grid .exp-detail-item .detail-value.amount {
  color: var(--accent-color);
  font-weight: 700;
}
.expense-card-main .expense-details-grid .exp-detail-item .detail-value.expense-type-tag {
  background-color: var(--primary-color);
  color: var(--text-color-light);
  padding: 0.2em 0.6em;
  border-radius: 0.25em;
  font-size: 0.85em;
  font-weight: 600;
}
.expense-card-main .expense-details-grid .exp-detail-item .detail-value.expense-court-ref {
  background-color: #f0f0f0;
  color: var(--text-color-dark);
  padding: 0.2em 0.6em;
  border-radius: 0.25em;
  font-size: 0.85em;
  font-weight: 500;
  border: 1px solid #d4d4d4;
}
.expense-card-main .expense-description {
  font-size: 0.9rem;
  color: var(--text-color-medium);
  line-height: 1.6;
  margin-bottom: var(--spacing-unit);
}
.expense-card-main .expense-description p {
  margin: 0;
}
.expense-card-main .expense-description p strong {
  color: var(--text-color-dark);
}
.expense-card-main .expense-document {
  margin-top: calc(var(--spacing-unit) * 0.5);
}
.expense-card-main .expense-document a {
  color: var(--primary-color);
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 600;
}
.expense-card-main .expense-document a:hover {
  text-decoration: underline;
}

.no-expenses {
  text-align: center;
  font-size: 1.1rem;
  color: var(--text-color-medium);
  padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);
  background: var(--card-bg);
  border-radius: 0.75rem;
  border: 1px dashed var(--border-color);
  box-shadow: 0 2px 5px var(--shadow-light);
  margin-top: calc(var(--spacing-unit) * 2);
  grid-column: 1/-1;
}

.error-msg {
  text-align: center;
  font-size: 0.95rem;
  color: var(--danger-color);
  background: #ffecec;
  padding: var(--spacing-unit) calc(var(--spacing-unit) * 1.5);
  border-radius: 0.375rem;
  border: 1px solid #ffccca;
  margin-bottom: var(--spacing-unit);
}

.pagination-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
  gap: 10px;
}
.pagination-controls button {
  padding: 6px 12px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  min-width: 80px;
  text-align: center;
}
.pagination-controls button:disabled {
  background: var(--primary-color);
  cursor: not-allowed;
  opacity: 0.6;
}

.pagination-settings {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  font-weight: 500;
  padding: 7px 18px;
  background-color: #E2E8F0;
  border-radius: 6px;
}
.pagination-settings label {
  white-space: nowrap;
  color: #1f2937;
  font-size: 14px;
  font-weight: 600;
}
.pagination-settings #expensePerPageSelect {
  border: none;
  border-radius: 6px;
  outline: none;
  padding: 6px 32px 6px 12px;
  background-color: white;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  min-width: 70px;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;
  transition: all 0.2s ease;
  box-shadow: none !important;
}
.pagination-settings #expensePerPageSelect:hover {
  background-color: #fafafa;
}
.pagination-settings #expensePerPageSelect:focus {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
  background-color: white;
}
.pagination-settings #expensePerPageSelect option {
  border: none !important;
  outline: none;
  padding: 4px 8px;
}

.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

@media (max-width: 768px) {
  .expense-container {
    padding: var(--spacing-unit);
    gap: var(--spacing-unit);
  }
  .expense-container .expense-card-main {
    padding: calc(var(--spacing-unit) * 1.5);
  }
  .expense-container .expense-card-main .expense-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    margin-bottom: var(--spacing-unit);
  }
  .expense-container .expense-card-main .expense-header .exp-main-detail .expense-courtRef-tag {
    background-color: #f0f0f0;
    color: var(--text-color-medium);
    padding: 0.2em 0.6em;
    border-radius: 0.25em;
    font-size: 0.8em;
    font-weight: 500;
    border: 1px solid #d4d4d4;
    display: inline-block;
  }
  .expense-container .expense-card-main .expense-header .exp-main-detail .expense-title {
    font-size: 1.3rem;
  }
  .expense-container .expense-card-main .expense-header .exp-main-detail .expense-actions {
    align-self: flex-end;
    margin-top: 0.5rem;
  }
  .expense-container .expense-card-main .expense-details-grid {
    grid-template-columns: 1fr;
    gap: 0.5rem;
    margin-bottom: var(--spacing-unit);
  }
  .expense-container .expense-card-main .expense-description,
  .expense-container .expense-card-main .expense-document {
    font-size: 0.85rem;
  }
}
@media (max-width: 480px) {
  .expense-container {
    padding: calc(var(--spacing-unit) * 0.5);
  }
  .expense-container .expense-card-main {
    padding: var(--spacing-unit);
  }
  .expense-container .expense-card-main .expense-header .exp-main-detail .expense-title {
    font-size: 1.1rem;
  }
  .expense-container .expense-card-main .expense-details-grid .exp-detail-item {
    font-size: 0.85rem;
  }
  .expense-container .expense-card-main .expense-details-grid .exp-detail-item .detail-icon {
    font-size: 1rem;
  }
}
.exp-courtRef-tag {
  margin-bottom: 1rem;
  background-color: #f0f0f0;
  color: var(--text-color-medium);
  padding: 0.2em 0.6em;
  border-radius: 0.25em;
  font-size: 0.8em;
  font-weight: 500;
  border: 1px solid #d4d4d4;
  display: inline-block;
}`, "",{"version":3,"sources":["webpack://./src/pages/Expenses/Expense.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,uBAAA;EACA,0BAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mCAAA;EACA,oCAAA;EACA,uBAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;AACF;AAAE;EACE,cAAA;EACA,kBAAA;AAEJ;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,2DAAA;EACA,wBAAA;EACA,sCAAA;EACA,+BAAA;AACF;;AAOA;EACE,WAAA;EACA,yBAAA;EACA,gCAAA;EACA,qCAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;AAJF;AAME;EACM,yBAAA;AAJR;AAMI;EACE,gBAAA;EACA,aAAA;EACA,cAAA;AAJN;AAUI;EACE,sCAAA;AARN;AAUM;EACE,yBAAA;AARR;AAWM;EACE,oBAAA;AATR;AAaM;EACE,mBAAA;AAXR;AAaQ;EACE,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;AAXV;AAaU;EACE,yBAAA;AAXZ;AAcU;EACE,YAAA;AAZZ;;AAmBA;EACE,0BAAA;EACA,qCAAA;EACA,sBAAA;EACA,sCAAA;EACA,gCAAA;EACA,kBAAA;AAhBF;AAiBE;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,qBAAA;EACA,mCAAA;EACA,4CAAA;AAfJ;AAiBI;EACE,iBAAA;EACA,gBAAA;EACA,6BAAA;EACA,SAAA;AAfN;AAkBI;EACE,aAAA;EACA,YAAA;AAhBN;AAkBM;EAWI,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AA1BV;AA2BU;EACE,+BAAA;EACA,YAAA;AAzBZ;AAgCE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8CAAA;AA9BJ;AAgCI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,+BAAA;AA9BN;AAgCM;EACE,2BAAA;EACA,kBAAA;EACA,oBAAA;AA9BR;AAiCM;EACE,gBAAA;EACA,6BAAA;EACA,qBAAA;EACA,YAAA;AA/BR;AAkCM;EACE,gBAAA;EACA,6BAAA;AAhCR;AAkCQ;EACE,0BAAA;EACA,gBAAA;AAhCV;AAmCQ;EACE,sCAAA;EACA,8BAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;AAjCV;AAoCQ;EACE,yBAAA;EACA,6BAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;AAlCV;AAwCE;EACE,iBAAA;EACA,+BAAA;EACA,gBAAA;EACA,kCAAA;AAtCJ;AAwCI;EACE,SAAA;AAtCN;AAwCM;EACE,6BAAA;AAtCR;AA2CE;EACE,2CAAA;AAzCJ;AA2CI;EACE,2BAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;AAzCN;AA2CM;EACE,0BAAA;AAzCR;;AA+CA;EACE,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,oEAAA;EACA,0BAAA;EACA,sBAAA;EACA,sCAAA;EACA,yCAAA;EACA,yCAAA;EACA,iBAAA;AA5CF;;AA+CA;EACE,kBAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;EACA,4DAAA;EACA,uBAAA;EACA,yBAAA;EACA,kCAAA;AA5CF;;AAgDA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,SAAA;AA7CF;AAgDE;EACE,iBAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AA9CJ;AAiDI;EACE,gCAAA;EACA,mBAAA;EACA,YAAA;AA/CN;;AAuDA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AApDF;AAuDE;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AArDJ;AAyDE;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,0BAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EAKA,gBAAA;EAGA,yDAAA;EACA,4BAAA;EACA,sCAAA;EACA,qBAAA;EAGA,yBAAA;EACA,2BAAA;AA7DJ;AAgEI;EACE,yBAAA;AA9DN;AAkEI;EACE,wDAAA;EACA,uBAAA;AAhEN;AAoEI;EACE,uBAAA;EACA,aAAA;EACA,gBAAA;AAlEN;;AAsEA;;EAEE,wBAAA;EACA,SAAA;AAnEF;;AAuEA;EACE;IACE,4BAAA;IACA,wBAAA;EApEF;EAsEE;IACE,wCAAA;EApEJ;EAsEI;IACE,sBAAA;IACA,uBAAA;IACA,WAAA;IACA,kCAAA;EApEN;EAyEQ;IACE,yBAAA;IACA,+BAAA;IACA,oBAAA;IACA,qBAAA;IACA,gBAAA;IACA,gBAAA;IACA,yBAAA;IACA,qBAAA;EAvEV;EA0EQ;IACE,iBAAA;EAxEV;EA2EQ;IACE,oBAAA;IACA,kBAAA;EAzEV;EAgFI;IACE,0BAAA;IACA,WAAA;IACA,kCAAA;EA9EN;EAiFI;;IAEE,kBAAA;EA/EN;AACF;AAoFA;EACE;IACE,wCAAA;EAlFF;EAoFE;IACE,4BAAA;EAlFJ;EAsFQ;IACE,iBAAA;EApFV;EA2FM;IACE,kBAAA;EAzFR;EA2FQ;IACE,eAAA;EAzFV;AACF;AA+FG;EACC,mBAAA;EACQ,yBAAA;EACA,+BAAA;EACA,oBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AA7FZ","sourcesContent":[":root {\n  --accent-color: #28a745;\n  --danger-color: #dc3545;\n  --text-color-dark: #343a40;\n  --text-color-medium: #6c757d;\n  --text-color-light: #f8f9fa;\n  --card-bg: #ffffff;\n  --container-bg: #f8f9fa;\n  --border-color: #e9ecef;\n  --shadow-light: rgba(0, 0, 0, 0.08);\n  --shadow-medium: rgba(0, 0, 0, 0.15);\n  --spacing-unit: 0.75rem;\n}\n\n.exp-main-div-header {\n  position: relative;\n  z-index: 1;\n  .filter-group label{\n    display: block;\n    margin-bottom: 8px;\n  }\n}\n\n.expense-container {\n  margin-top: 1rem;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: var(--spacing-unit);\n  padding: calc(var(--spacing-unit) * 2);\n  background: var(--container-bg);\n\n}\n// .min-height-applied {\n//   min-height: 50vh;\n//   transition: min-height 0.3s ease;\n// }\n\n.expenses-table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: var(--card-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 0.5rem;\n  overflow: hidden;\n  font-size: 0.95rem;\n  box-shadow: 0 2px 6px var(--shadow-light);\n\n  thead {\n        background-color: #f1f5f9;\n\n    th {\n      text-align: left;\n      padding: 1rem;\n      color: #111827;\n      // border: 1px solid #ddd;\n    }\n  }\n\n  tbody {\n    tr {\n      transition: background-color 0.2s ease;\n\n      &:hover {\n        background-color: #f9fafb;\n      }\n\n      td {\n        padding: 0.9rem 1rem;\n        // border: 1px solid #ddd;\n      }\n\n      td:last-child {\n        white-space: nowrap;\n\n        button {\n          margin-right: 0.5rem;\n          padding: 0.3rem 0.6rem;\n          font-size: 0.85rem;\n          border: none;\n          border-radius: 4px;\n          cursor: pointer;\n          background-color: #17a2b8;\n          color: white;\n\n          &:last-child {\n            background-color: #dc2626; // red for delete\n          }\n\n          &:hover {\n            opacity: 0.9;\n          }\n        }\n      }\n    }\n  }\n}\n.expense-card-main {\n  background: var(--card-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 0.75rem;\n  padding: calc(var(--spacing-unit) * 2);\n  transition: all 0.2s ease-in-out;\n  position: relative;\n  .expense-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: start;\n    margin-bottom: 0.5rem;\n    padding-bottom: var(--spacing-unit);\n    border-bottom: 1px solid var(--border-color);\n\n    .expense-title {\n      font-size: 1.3rem;\n      font-weight: 700;\n      color: var(--text-color-dark);\n      margin: 0;\n    }\n\n    .expense-actions {\n      display: flex;\n      gap: 0.75rem;\n\n      .action-button {\n        // background: none;\n        // border: 1px solid var(--border-color);\n        // border-radius: 50%;\n        // width: 1.8rem;\n        // height: 1.8rem;\n        // display: flex;\n        // align-items: center;\n        // justify-content: center;\n        // cursor: pointer;\n        // transition: all 0.2s ease;\n          margin-right: 0.5rem;\n          padding: 0.3rem 0.6rem;\n          font-size: 0.85rem;\n          border: none;\n          border-radius: 4px;\n          cursor: pointer;\n          &:hover {\n            background: var(--container-bg);\n            opacity: 0.9;\n          }\n      }\n      \n    }\n  }\n\n  .expense-details-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem 1.5rem;\n    margin-bottom: calc(var(--spacing-unit) * 1.5);\n\n    .exp-detail-item {\n      display: flex;\n      align-items: center;\n      font-size: 0.95rem;\n      color: var(--text-color-medium);\n\n      .detail-icon {\n        color: var(--primary-color);\n        font-size: 1.15rem;\n        margin-right: 0.5rem;\n      }\n\n      .detail-label {\n        font-weight: 600;\n        color: var(--text-color-dark);\n        margin-right: 0.25rem;\n        width: 100px;\n      }\n\n      .detail-value {\n        font-weight: 500;\n        color: var(--text-color-dark);\n\n        &.amount {\n          color: var(--accent-color);\n          font-weight: 700;\n        }\n\n        &.expense-type-tag {\n          background-color: var(--primary-color);\n          color: var(--text-color-light);\n          padding: 0.2em 0.6em;\n          border-radius: 0.25em;\n          font-size: 0.85em;\n          font-weight: 600;\n        }\n\n        &.expense-court-ref {\n          background-color: #f0f0f0;\n          color: var(--text-color-dark);\n          padding: 0.2em 0.6em;\n          border-radius: 0.25em;\n          font-size: 0.85em;\n          font-weight: 500;\n          border: 1px solid #d4d4d4;\n        }\n      }\n    }\n  }\n\n  .expense-description {\n    font-size: 0.9rem;\n    color: var(--text-color-medium);\n    line-height: 1.6;\n    margin-bottom: var(--spacing-unit);\n\n    p {\n      margin: 0;\n\n      strong {\n        color: var(--text-color-dark);\n      }\n    }\n  }\n\n  .expense-document {\n    margin-top: calc(var(--spacing-unit) * 0.5);\n\n    a {\n      color: var(--primary-color);\n      text-decoration: none;\n      font-size: 0.9rem;\n      font-weight: 600;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  }\n}\n\n.no-expenses {\n  text-align: center;\n  font-size: 1.1rem;\n  color: var(--text-color-medium);\n  padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);\n  background: var(--card-bg);\n  border-radius: 0.75rem;\n  border: 1px dashed var(--border-color);\n  box-shadow: 0 2px 5px var(--shadow-light);\n  margin-top: calc(var(--spacing-unit) * 2);\n  grid-column: 1/-1;\n}\n\n.error-msg {\n  text-align: center;\n  font-size: 0.95rem;\n  color: var(--danger-color);\n  background: #ffecec;\n  padding: var(--spacing-unit) calc(var(--spacing-unit) * 1.5);\n  border-radius: 0.375rem;\n  border: 1px solid #ffccca;\n  margin-bottom: var(--spacing-unit);\n}\n\n\n.pagination-controls {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 20px 0;\n  gap: 10px;\n\n\n  button {\n    padding: 6px 12px;\n    background: var(--primary-color);\n    color: white;\n    border: none;\n    border-radius: 10px;\n    cursor: pointer;\n    min-width: 80px;\n    text-align: center;\n\n\n    &:disabled {\n      background: var(--primary-color);\n      cursor: not-allowed;\n      opacity: 0.6;\n    }\n  }\n}\n\n\n\n\n.pagination-settings {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 15px;\n  font-weight: 500;\n  padding: 7px 18px;\n  background-color: #E2E8F0;\n  border-radius: 6px;\n\n\n  label {\n    white-space: nowrap;\n    color: #1f2937;\n    font-size: 14px;\n    font-weight: 600;\n  }\n\n\n  #expensePerPageSelect {\n    border: none;\n    border-radius: 6px;\n    outline: none;\n    padding: 6px 32px 6px 12px;\n    background-color: white;\n    font-size: 14px;\n    color: #333;\n    cursor: pointer;\n    min-width: 70px;\n\n\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n\n\n    background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%23666'%3e%3cpath fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right 10px center;\n    background-size: 16px;\n\n\n    transition: all 0.2s ease;\n    box-shadow: none !important;\n\n\n    &:hover {\n      background-color: #fafafa;\n    }\n\n\n    &:focus {\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;\n      background-color: white;\n    }\n\n\n    option {\n      border: none !important;\n      outline: none;\n      padding: 4px 8px;\n    }\n  }\n}\n.no-spinner::-webkit-outer-spin-button,\n.no-spinner::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n// Responsive Design\n@media (max-width: 768px) {\n  .expense-container {\n    padding: var(--spacing-unit);\n    gap: var(--spacing-unit);\n\n    .expense-card-main {\n      padding: calc(var(--spacing-unit) * 1.5);\n\n      .expense-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 0.5rem;\n        margin-bottom: var(--spacing-unit);\n\n        .exp-main-detail {\n\n\n          .expense-courtRef-tag {\n            background-color: #f0f0f0;\n            color: var(--text-color-medium);\n            padding: 0.2em 0.6em;\n            border-radius: 0.25em;\n            font-size: 0.8em;\n            font-weight: 500;\n            border: 1px solid #d4d4d4;\n            display: inline-block;\n          }\n\n          .expense-title {\n            font-size: 1.3rem;\n          }\n\n          .expense-actions {\n            align-self: flex-end;\n            margin-top: 0.5rem;\n          }\n        }\n\n\n      }\n\n      .expense-details-grid {\n        grid-template-columns: 1fr;\n        gap: 0.5rem;\n        margin-bottom: var(--spacing-unit);\n      }\n\n      .expense-description,\n      .expense-document {\n        font-size: 0.85rem;\n      }\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .expense-container {\n    padding: calc(var(--spacing-unit) * 0.5);\n\n    .expense-card-main {\n      padding: var(--spacing-unit);\n\n      .expense-header {\n        .exp-main-detail {\n          .expense-title {\n            font-size: 1.1rem;\n          }\n        }\n\n      }\n\n      .expense-details-grid {\n        .exp-detail-item {\n          font-size: 0.85rem;\n\n          .detail-icon {\n            font-size: 1rem;\n          }\n        }\n      }\n    }\n  }\n}\n   .exp-courtRef-tag {\n    margin-bottom: 1rem;\n            background-color: #f0f0f0;\n            color: var(--text-color-medium);\n            padding: 0.2em 0.6em;\n            border-radius: 0.25em;\n            font-size: 0.8em;\n            font-weight: 500;\n            border: 1px solid #d4d4d4;\n            display: inline-block;\n          }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
